import { FC, useCallback } from "react";
import cn from "classnames";
import { useGetURLQuery } from "capitalrx-components-2.0/lib/hooks";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { useAlert, Tag } from "capitalrx-components-2.0/lib/general";
import { QueryParams } from "@/api/interfaces/QueryParams";
import BackButton from "@/components/BackButton/BackButton";

import styles from "./FindBestPriceActionBar.module.scss";

const FindBestPriceActionBar: FC = () => {
  const showAlert = useAlert();

  const failureHandler = useCallback(
    (err: string | Error): void => {
      showAlert({ type: "error", message: typeof err === "string" ? err : err.message, style: "banner" });
    },
    [showAlert],
  );

  const getURLQuery = useGetURLQuery<QueryParams>(failureHandler);
  const { dosage, drug_name, dosage_form, zipcode, quantity } = getURLQuery;

  const searchSummaryNoMobile = cn(styles["SearchSummary"], "NoMobile", { [styles["Hide"]]: drug_name === undefined });

  return (
    <div className={styles.ActionBar} test-id="advantage-action-bar">
      <BackButton />
      <div className={searchSummaryNoMobile}>
        <div className={styles.SearchSummaryAttributes}>
          <Paragraph>BEST PRICE FOR:</Paragraph>
          <div className={styles.SearchSummaryTags}>
            <Tag type="info" testId="searched-drug-name">
              {drug_name}
            </Tag>
            <Tag type="info" testId="searched-drug-dosage">
              {dosage}
            </Tag>

            <Tag type="info" testId="searched-drug-form">
              {dosage_form}
            </Tag>

            <Tag type="info" testId="searched-drug-quantity">
              {quantity}
            </Tag>
          </div>
        </div>
        <div className={styles.SearchSummaryLocation} data-testid="searched-location">
          <Paragraph>LOCATION:</Paragraph>
          <Tag type="info" testId="searched-zipcode">
            {zipcode}
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default FindBestPriceActionBar;
